export default new Vue();



// WEBPACK FOOTER //
// ./dev/src/eventHub.js